import { useState, useEffect } from 'react';
import MunicipalityManagement from './MunicipalityManagement';
import SiteList from './SiteList';
import UnitManagement from './UnitManagement';

const SiteManagement = () => {
  const [activeTab, setActiveTab] = useState('municipalities');
  const [selectedSite, setSelectedSite] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // Refresh the data when needed
  const refreshData = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Reset selected site when changing to municipalities tab
  useEffect(() => {
    if (activeTab === 'municipalities') {
      setSelectedSite(null);
    }
  }, [activeTab]);
  
  // Handle site selection for unit management
  const handleSiteSelect = (site) => {
    setSelectedSite(site);
    setActiveTab('units');
  };

  return (
    <div>
      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center">
          <li className="mr-2">
            <button
              className={`inline-block p-4 rounded-t-lg ${
                activeTab === 'municipalities'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('municipalities')}
            >
              Municipalities
            </button>
          </li>
          <li className="mr-2">
            <button
              className={`inline-block p-4 rounded-t-lg ${
                activeTab === 'sites'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('sites')}
            >
              Sites
            </button>
          </li>
          <li className="mr-2">
            <button
              className={`inline-block p-4 rounded-t-lg ${
                activeTab === 'units'
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('units')}
            >
              Units
            </button>
          </li>
        </ul>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === 'municipalities' && (
          <MunicipalityManagement key={`municipalities-${refreshKey}`} onRefresh={refreshData} />
        )}
        
        {activeTab === 'sites' && (
          <SiteList 
            key={`sites-${refreshKey}`} 
            onRefresh={refreshData} 
            onSiteSelect={handleSiteSelect} 
          />
        )}
        
        {activeTab === 'units' && (
          <UnitManagement 
            key={`units-${refreshKey}-${selectedSite?.uuid || 'no-site'}`} 
            siteUuid={selectedSite?.uuid} 
            siteName={selectedSite?.name}
            onRefresh={refreshData} 
          />
        )}
      </div>
    </div>
  );
};

export default SiteManagement; 